import ActionTypes from '../constants/ActionTypes';

export const getCodingProblemData = problem => ({
  type: ActionTypes.SET_CODING_PROBLEM_DATA,
  problem,
});

export const switchEditorTheme = () => ({
  type: ActionTypes.SWITCH_EDITOR_THEME,
});

export const setupCodingEnvironment = () => ({
  type: ActionTypes.SETUP_CODING_ENVIRONMENT,
});

export const onChangeLanguage = (languageUri, problem) => ({
  type: ActionTypes.CHANGE_LANGUAGE,
  languageUri,
  problem,
});

export const setLibraryLoaded = () => ({
  type: ActionTypes.SET_LIBRARY_LOADED_SUCCESS,
});

export const onCustomInputChange = (input, problemSlug) => ({
  type: ActionTypes.SET_CODING_CUSTOM_INPUT,
  problemSlug,
  input,
});

export const runCodeCustomInput = (
  problemSlug,
  problemId,
  problemType,
  isTestQuery
) => ({
  type: ActionTypes.RUN_CODE_CUSTOM_INPUT,
  problemType,
  problemSlug,
  problemId,
  isTestQuery,
});

export const runCustomInputResult = data => ({
  type: ActionTypes.RUN_CODE_CUSTOM_INPUT_RESULT,
  data,
});

export const runTestCases = (problem, retryCallback) => ({
  type: ActionTypes.RUN_CODE_TEST_CASES,
  problem,
  retryCallback,
});

export const runTestCasesResult = data => ({
  type: ActionTypes.RUN_CODE_TEST_CASES_RESULT,
  data,
});

export const resetRunCodeData = problemSlug => ({
  type: ActionTypes.RESET_RUN_CODE_DATA,
  problemSlug,
});

export const abortRunCode = problemSlug => ({
  type: ActionTypes.ABORT_RUN_CODE,
  problemSlug,
});

export const resetProblemData = problemSlug => ({
  type: ActionTypes.RESET_PROBLEM_DATA,
  problemSlug,
});

export const autoAbortRunCode = problemSlug => ({
  type: ActionTypes.AUTO_ABORT_RUN_CODE,
  problemSlug,
});

export const getTechnologies = () => ({
  type: ActionTypes.GET_TECHNOLOGIES,
});

export const onCodeChange = (code, problem) => ({
  type: ActionTypes.ON_CODE_CHANGE,
  problem,
  code,
});

export const onCodeChangeNoDebounce = (code, problem) => ({
  type: ActionTypes.SAVE_CODE_NO_DEBOUNCE,
  problem,
  code,
});

export const onCodeSave = (
  code,
  problem,
  isAutoSave = true,
  retryCallback
) => ({
  type: ActionTypes.SAVE_CODING_PROBLEM,
  code,
  problem,
  isAutoSave,
  retryCallback,
});
